import { ServiceClient, ServiceError } from "@securityjourney/service-client";
export class ChoresClient extends ServiceClient {
    constructor(getToken, baseUrl) {
        super({
            getToken,
            url: baseUrl,
        });
    }
    // create or update the given assignment
    // Returns 409 Conflict if an assignment already exists in this tenant with the given name.
    assign(assignment) {
        const func = this.fetcher.path("/svc/chores/assignment").method("post").create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func(assignment, init))
                .then(response => response.data.uuid)
                .catch(ServiceError.raise),
        };
    }
    myChores(forTenant) {
        const func = this.fetcher.path("/svc/chores/me").method("get").create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({
                forTenant,
            }, init))
                .then(response => response.data)
                .catch(ServiceError.raise),
        };
    }
    get(id) {
        const func = this.fetcher.path("/svc/chores/assignment/{uuid}").method("get").create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({
                uuid: id,
            }, init))
                .then(response => response.data)
                .catch(ServiceError.raise),
        };
    }
    getAvailableStatuses() {
        const func = this.fetcher.path("/svc/chores/facets/overall-status").method("get").create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({}, init))
                .then(response => response.data)
                .catch(ServiceError.raise),
        };
    }
    getAssessments(tenant) {
        const func = this.fetcher
            .path("/svc/chores/{tenant}/knowledge-assessments/status")
            .method("get")
            .create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({
                tenant: tenant,
            }, init))
                .then(response => response.data)
                .catch(ServiceError.raise),
        };
    }
    getAssessment(tenant, assessmentId) {
        const func = this.fetcher
            .path("/svc/chores/{tenant}/knowledge-assessments/{assessment_uuid}/status")
            .method("get")
            .create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({
                tenant: tenant,
                assessment_uuid: assessmentId,
            }, init))
                .then(response => response.data)
                .catch(ServiceError.raise),
        };
    }
    archive(id) {
        const func = this.fetcher
            .path("/svc/chores/assignment/{assignment_uuid}/archive")
            .method("post")
            .create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({
                assignment_uuid: id,
            }, init))
                .then(() => undefined)
                .catch(ServiceError.raise),
        };
    }
    unarchive(id) {
        const func = this.fetcher
            .path("/svc/chores/assignment/{assignment_uuid}/unarchive")
            .method("post")
            .create();
        const { init, abort } = this.withAbort();
        return {
            abort,
            promise: this.withAuthorization(init)
                .then(init => func({
                assignment_uuid: id,
            }, init))
                .then(() => undefined)
                .catch(ServiceError.raise),
        };
    }
}
//# sourceMappingURL=chores.js.map